<template>
<PageView title="专家年度评价登记">
  <template slot="action">
    <a-button type="primary" @click="add">保存</a-button>
  </template>
  <ExpertYearAssessForm ref="accidentForm"/>
</PageView>
</template>

<script>
import { PageView } from '@/layouts'
import ExpertYearAssessForm from '@/epp/expertmain/expertyearassess/common/ExpertYearAssessForm'
export default {
  name: 'ExpertYearAssessAdd',
  components: { PageView,
    ExpertYearAssessForm },
  methods: {
    add() {
      this.$refs.accidentForm.submit()
    }
  }
}
</script>

<style scoped>

</style>
